"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var datatable_1 = __importDefault(require("../datatable"));
var pagegghq_1 = __importDefault(require("../quteinfo/pagegghq")); //行业行情
var fieldtools_1 = __importDefault(require("../commonutil/fieldtools"));
var delayquote_1 = require("../delayquote");
function default_1() {
    //机构一致看多个股 
    return new datatable_1["default"]({
        table_type: 'zw_mutiplestock',
        div_id: 'zw_mutiplestock_table',
        pager_id: '',
        tableclass: 'zw_table',
        dataurl: {
            hostname: 'datacenter',
            url: 'api/data/v1/get',
            params: {
                reportName: 'RPT_WEB_RESPREDICT',
                columns: 'SECURITY_CODE,SECURITY_NAME_ABBR,RATING_LONG_NUM,DEC_AIMPRICEMAX,DEC_AIMPRICEMIN',
                quoteColumns: "f2",
                quoteType: delayquote_1.hsaDelay() ? "1" : "0",
                pageNumber: 1,
                pageSize: 15,
                sortTypes: -1,
                sortColumns: 'RATING_LONG_NUM'
            }
        },
        columns: {
            config: [
                {
                    th: function name(v) {
                        return '名称';
                    },
                    td: function (v) {
                        return "<a href=\"/stockdata/" + v.SECURITY_CODE + (".html\">" + fieldtools_1["default"].fmtsname(v.SECURITY_NAME_ABBR) + "</a>");
                    }
                },
                {
                    th: function name(v) {
                        return '研报';
                    },
                    td: function (v) {
                        return "<a href=\"/report/" + v.SECURITY_CODE + ".html\" class=\"\">\u8BE6\u7EC6</a>";
                    }
                },
                {
                    th: function name(v) {
                        return '看多<br>家数';
                    },
                    td: function (v) {
                        return fieldtools_1["default"].isEmpty(v.RATING_LONG_NUM) ? 0 : v.RATING_LONG_NUM;
                    }
                },
                {
                    th: function name(v) {
                        return '最高<br>目标价';
                    },
                    td: function (v) {
                        return fieldtools_1["default"].fieldfmt(v.DEC_AIMPRICEMAX, { num: 2 });
                    }
                },
                {
                    th: function name(v) {
                        return '最低<br>目标价';
                    },
                    td: function (v) {
                        return fieldtools_1["default"].fieldfmt(v.DEC_AIMPRICEMIN, { num: 2 });
                    }
                },
                {
                    th: function name(v) {
                        return '现价';
                    },
                    td: function (v) {
                        return fieldtools_1["default"].fieldfmt(v.f2, { num: 2 });
                    }
                }
            ]
        },
        onShowComplete: function () {
            pagegghq_1["default"]('zw_mutiplestock_table');
        }
    });
}
exports["default"] = default_1;
